import '../plugins/custom-select.min.js';

const selectedCar = document.querySelector('#select-car');
if(selectedCar) {
    customSelect(selectedCar);
    selectedCar.addEventListener('change', fillContent);
}

const selectedBusinessCar = document.querySelector('#select-business-car');
if(selectedBusinessCar) {
    customSelect(selectedBusinessCar);
    selectedBusinessCar.addEventListener('change', fillContent);
}

document.querySelector('#toggle-type').addEventListener('click', e => {
    const btn = e.srcElement;

    if(btn.dataset.setCookie === 'yes') {
        if(btn.classList.contains('toggle--private')) {
            createCookie('customer-type', 'business', 14);
        } else if(btn.classList.contains('toggle--business')) {
            createCookie('customer-type', 'private', 14);
        }
    }

    fillContent(e)
    btn.classList.toggle('toggle--business');
    btn.classList.toggle('toggle--private');
    btn.parentNode.parentNode.classList.toggle('business');
    btn.parentNode.parentNode.classList.toggle('private');
});

function fillContent(e){
    const form = new FormData();
    form.append('action', 'nobox_change_customer_type');
    if(e) {
        form.append('post_id', e.srcElement.dataset.postId);
        form.append('car', selectedCar && selectedCar.value ? selectedCar.value : '');
    } else if(selectedCar) {
        form.append('post_id', selectedCar.dataset.postId);
        form.append('car', selectedCar.value ? selectedCar.value : '');
    }

    const params = new URLSearchParams(form);

    fetch(horizon.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: params
    })
    .then(response => response.json())
    .then(data => {
        if(data.errors) {
            console.error(data.errors);
            return;
        } else {
            if(document.querySelector('.finance-block__price--lease')) {
                document.querySelectorAll('.finance-block__price--lease').forEach(item => {
                    item.textContent = data.lease + ' kr/mån';
                });
            }
            if(document.querySelector('#leaseButton')) {
                document.querySelector('#leaseButton').href = data.url;
            }
            if(document.querySelector('#price')) {
                if(parseInt(data.price) && parseInt(data.price) > 0) {
                    document.querySelector('#price').textContent = data.price + ' kr';
                } else {
                    document.querySelector('#price').textContent = 'Pris på förfrågan';
                }
            }
            if(document.querySelector('#priceText')) {
                document.querySelector('#priceText').textContent = data.priceText;
            }
            if(document.querySelector('#delivery_from')) {
                document.querySelector('#delivery_from').textContent = data.delivery_from;
            }
            if(document.querySelector('#delivery_to')) {
                document.querySelector('#delivery_to').textContent = data.delivery_to;
            }
        }
    })
}

function createCookie(name, value, days = "", hours = false) {
    if (days) {
      var date = new Date();
      if(hours) {
          date.setTime(date.getTime() + (days * 60 * 60 * 1000));
      } else {
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      }
      var expires = "; expires=" + date.toGMTString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}
